import { postFetch, getFetch } from '@/utils/request'

export function getRegionTreesData() {
    return getFetch('/region/getRegionTrees', {});
}

export function getAllCountryData() {
    return getFetch('/region/getAllCountry', {});
}

export function getAllProvinceData() {
    return getFetch('/region/getAllProvinces', {});
}

export function getRegionByParentId(parentId) {
    return getFetch('/region/getRegionParentId', {parentId: parentId})
}

export function getCascadeRegionData() {
    return getFetch('/region/getCascadeRegion', {})
}



// WEBPACK FOOTER //
// ./src/api/common/regionApi.js